{
  "name": "remitos-pwa",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "generate:version": "node scripts/generate-version.mjs",
    "check:release-version": "node scripts/check-release-version.mjs",
    "prestart": "npm run generate:version",
    "start": "ng serve",
    "prestart:network": "npm run generate:version",
    "start:network": "ng serve --host 0.0.0.0",
    "prestart:ssl": "npm run generate:version",
    "start:ssl": "ng serve --host 0.0.0.0 --ssl --ssl-cert=ssl/cert.pem --ssl-key=ssl/key.pem",
    "prebuild": "npm run generate:version && npm run check:release-version",
    "build": "ng build",
    "prebuild:dev": "npm run generate:version",
    "build:dev": "ng build --configuration=development",
    "serve:dev": "npm run build:dev && npx http-server ./dist/remitos-pwa/browser -p 8080 -a 0.0.0.0",
    "start:api-proxy": "node scripts/dev-api-proxy.mjs",
    "start:api-proxy:prod": "node server/api-proxy.mjs",
    "serve:smarterasp:local": "node server/smarterasp-server.mjs",
    "serve:smarterasp:prod": "node server/smarterasp-server.mjs",
    "smarterasp:smoke": "node server/smarterasp-server.mjs",
    "prewatch": "npm run generate:version",
    "watch": "ng build --watch --configuration development",
    "pretest": "npm run generate:version",
    "test": "ng test",
    "test:coverage": "ng test --watch=false --coverage",
    "test:coverage:ci": "node scripts/check-coverage-thresholds.mjs",
    "audit:dev": "npm audit --audit-level=moderate",
    "docs:governance:check": "node scripts/check-doc-governance.mjs",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "e2e": "playwright test",
    "e2e:headed": "playwright test --headed --project=chromium",
    "e2e:ci": "playwright test --reporter=line",
    "serve:prod": "npm run serve:smarterasp:prod",
    "quality:check": "npm run lint && npm test -- --watch=false && npm run build",
    "hooks:install": "git config core.hooksPath .githooks",
    "hooks:status": "git config --get core.hooksPath"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.6.1",
  "dependencies": {
    "@angular/common": "^21.2.9",
    "@angular/compiler": "^21.2.9",
    "@angular/core": "^21.2.9",
    "@angular/platform-browser": "^21.2.9",
    "@angular/router": "^21.2.9",
    "@angular/service-worker": "^21.2.9",
    "@fingerprintjs/fingerprintjs": "^5.0.1",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "idb": "^8.0.3",
    "lucide-angular": "^0.575.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/build": "^21.2.8",
    "@angular/cli": "^21.2.8",
    "@angular/compiler-cli": "^21.2.9",
    "@eslint/js": "^9.39.3",
    "@playwright/test": "^1.58.2",
    "@tailwindcss/postcss": "^4.1.12",
    "@typescript-eslint/eslint-plugin": "^8.48.0",
    "@typescript-eslint/parser": "^8.48.0",
    "@vitest/coverage-v8": "^4.0.18",
    "angular-eslint": "^21.3.1",
    "baseline-browser-mapping": "^2.9.18",
    "eslint": "^9.39.3",
    "jsdom": "^27.1.0",
    "postcss": "^8.5.3",
    "tailwindcss": "^4.1.12",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.48.0",
    "vitest": "^4.0.8"
  }
}
